@if (initialError && !initialLoading) {
  <div class="initial-error">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <span class="error-message">{{ initialError }}</span>
      <button type="button" mat-stroked-button color="primary" (click)="onRetryClick()">
      {{ 'DEAD_LETTERS.ACTIONS.RETRY' | translate }}
    </button>
  </div>
}

@if (!initialError || initialLoading) {
  <div class="list-header">
    <div class="selection">
      <mat-checkbox
        [checked]="selectAll"
        (change)="onSelectAllChange($event.checked)"
        [attr.aria-label]="'DEAD_LETTERS.ACTIONS.SELECT_ALL_ARIA_LABEL' | translate">
      </mat-checkbox>
    </div>
    <div class="header-content">
      <div class="header-cell col-id">
        <span>{{ 'DEAD_LETTERS.COLUMNS.ID' | translate }}</span>
      </div>
      <div class="header-cell col-company-name">
        <span>{{ 'DEAD_LETTERS.COLUMNS.COMPANY_NAME' | translate }}</span>
      </div>
      <div class="header-cell col-company-id">
        <span>{{ 'DEAD_LETTERS.COLUMNS.COMPANY_ID' | translate }}</span>
      </div>
      <div class="header-cell col-time">
        <span>{{ 'DEAD_LETTERS.COLUMNS.EVENT_TIME' | translate }}</span>
      </div>
      <div class="header-cell col-reason">
        <span>{{ 'DEAD_LETTERS.COLUMNS.REASON' | translate }}</span>
      </div>
      <div class="header-cell col-event-type">
        <span>{{ 'DEAD_LETTERS.COLUMNS.EVENT_TYPE' | translate }}</span>
      </div>
    </div>
    <div class="header-actions"></div>
  </div>
  @if (initialLoading) {
    <div class="content-loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
  @if (!initialLoading) {
    @if (items.length > 0) {
      <div class="viewport-wrapper">
        <cdk-virtual-scroll-viewport
          class="viewport"
          [itemSize]="64">
          <div
            *cdkVirtualFor="let item of items"
            class="row">
            <div class="selection">
              <mat-checkbox
                [checked]="isSelected(item.id)"
                (change)="onSelectionChange(item.id, $event.checked)"
                [attr.aria-label]="'DEAD_LETTERS.ACTIONS.SELECT_ROW_ARIA_LABEL' | translate">
              </mat-checkbox>
            </div>
            <div class="row-content">
              <div class="cell col-id">
                <a class="id-link" [matTooltip]="item.id" (click)="onIdClick(item.id)">{{ item.id }}</a>
              </div>
              <div class="cell col-company-name" [appCopyToClipboard]="item.enrichment?.company?.name ?? ''" [matTooltip]="item.enrichment?.company?.name ?? ''">
                {{ item.enrichment?.company?.name || ('DEAD_LETTERS.VALUES.UNKNOWN_COMPANY' | translate) }}
              </div>
              <div class="cell col-company-id" [appCopyToClipboard]="item.enrichment?.company?.id ?? ''" [matTooltip]="item.enrichment?.company?.id ?? ''">
                {{ item.enrichment?.company?.id }}
              </div>
              <div class="cell col-time" [matTooltip]="item.eventTime">
                {{ item.eventTime | date:'M/d/yy, h:mm:ss.SSS a' }}
              </div>
              <div class="cell col-reason" [matTooltip]="item.deadLetterReason">
                <span>{{ item.deadLetterReason }}</span>
              </div>
              <div class="cell col-event-type" [matTooltip]="item.eventType">
                {{ item.eventType }}
              </div>
            </div>
            <div class="row-actions">
              @if (!actionInProgressIds.has(item.id)) {
                <button
                  mat-icon-button
                  type="button"
                  (click)="onReplayClick(item.id)"
                  [attr.aria-label]="'DEAD_LETTERS.ACTIONS.REPLAY_ARIA_LABEL' | translate">
                  <mat-icon>replay</mat-icon>
                </button>
                <button
                  mat-icon-button
                  type="button"
                  (click)="onRemoveClick(item.id)"
                  [attr.aria-label]="'DEAD_LETTERS.ACTIONS.REMOVE_ARIA_LABEL' | translate">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              } @else {
                <mat-spinner diameter="24"></mat-spinner>
              }
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
        @if (appendLoading) {
          <div class="append-loading">
            <mat-spinner diameter="28"></mat-spinner>
            <span>{{ 'DEAD_LETTERS.LOADING.MORE' | translate }}</span>
          </div>
        }
      </div>
    }
    @if (items.length === 0) {
      <div class="empty-state">
        <mat-icon class="empty-icon">inbox</mat-icon>
        @if (hasActiveFilters) {
          <span class="empty-message">{{ 'DEAD_LETTERS.EMPTY.NO_RESULTS_FILTERED' | translate }}</span>
        }
        @if (!hasActiveFilters) {
          <span class="empty-message">{{ 'DEAD_LETTERS.EMPTY.NO_RESULTS' | translate }}</span>
        }
      </div>
    }
  }
}
